import React, { useEffect, useMemo, useState } from 'react'
import { UnoStoreHooks } from "@simulanisindia/ui";
import UserTab from '../TeamManagement/Tabs/UserTab'
import SelectionLine from '../SelectionLine';
import { USER_LIMIT, USER_TAB_TYPE } from '../../constant/constants';
import apiClient from '../../apiClient';
import { GROUP_USERS_LIST, MULTIPLE_CHANGE_STATUS } from '../../apiClient/apiEndpoints';

const { useUnoSelector } = UnoStoreHooks;

const UserContent = ({ search, UUID, selectedFilter, refreshTab,isMobileView }) => {
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData.config.UNO_URL
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [paginationPage, setPaginationPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);

  const memoizedFilters = useMemo(() => {
    return { search, selectedFilter };
  }, [search, selectedFilter]);

  const handleClearSelection = () => {
    setSelectedItems([]);
  };

  const getUsersList = async (pageId, searchParameter = null, groupSelectedCheckboxes = []) => {
    let pageNumber = pageId || paginationPage;
    try {
      setHasMore(true);
      let data = await apiClient.get(`${UNO_URL}${GROUP_USERS_LIST}/${UUID}`, {
        params: {
          limit: USER_LIMIT,
          page: pageNumber,
          search: searchParameter || null,
          roleIds:
            groupSelectedCheckboxes.length > 0
              ? groupSelectedCheckboxes.filter((e) => e.type === "role").map((e) => e.value)
              : null,
          status:
            groupSelectedCheckboxes.length > 0
              ? groupSelectedCheckboxes.filter((e) => e.type === "status").map((e) => e.key)
              : null,
        },
      });
      setList((pre) => (pageNumber == 1 ? [...data] : [...pre, ...data]));
      setHasMore(data.length === USER_LIMIT);
      setPaginationPage(data.length === USER_LIMIT ? Number(pageNumber) + 1 : 1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setList([]);
    setLoading(true);
    getUsersList(1, memoizedFilters.search, memoizedFilters.selectedFilter);
  }, [UUID, memoizedFilters, refreshTab]);

  const handleChangeLocallyStatus = ({ ids, status }) => {
    let _list = list.map((e) => (ids.includes(e.uuid) ? { ...e, active: status } : e));
    setList(_list);
  };

  const handleSelectAllItems = (action) => {
    let filterItem = {
      all: list.map((e) => ({ id: e.uuid, data: e })),
      none: [],
      active: list.filter((f) => f.active).map((e) => ({ id: e.uuid, data: e })),
      inactive: list.filter((f) => !f.active).map((e) => ({ id: e.uuid, data: e })),
    };
    setSelectedItems(filterItem[action]);
  };

  const handleMultipleStatusChange = async (status) => {
    try {
      let ids = selectedItems.map((e) => e.id);

      let bodyData = {
        status: status,
        ids: ids,
      };

      handleChangeLocallyStatus({ ids: ids, status: status });
      await apiClient.post(`${UNO_URL}${MULTIPLE_CHANGE_STATUS}/user`, bodyData);
      handleClearSelection();
    } catch (error) {
      console.log(error);
    }
  };

  const handleTriggerRefreshHandler = () => {
    getUsersList(1, search, selectedFilter);
  }


  return (
    <>
    {!isMobileView &&  
    <SelectionLine
        buttonShow={true}
        type={USER_TAB_TYPE}
        showAssignIcon={selectedItems.length > 0}
        showMoveIcon={selectedItems.length > 0}
        showStatusChangeIcon={selectedItems.length > 0}
        triggerRefreshHandler={handleTriggerRefreshHandler}
        handleClickMultipleSelect={(e) => handleSelectAllItems(e)}
        selectedItems={selectedItems}
        handleClearSelection={handleClearSelection}
        multipleProfileStatusChange={handleMultipleStatusChange}
        totalItemsCount={list.length}
        text={
          selectedItems.length > 0 && (
            <>
              {selectedItems.length} {selectedItems.length > 1 ? "Users are " : "User is"} selected.
              <span className="cursor-pointer text-primary" onClick={handleClearSelection}>
                {" "}
                Clear Selection{" "}
              </span>
            </>
          )
        }
      />}

      <UserTab
        list={list}
        search={search}
        loading={loading}
        hasMore={hasMore}
        paginationPage={paginationPage}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        handleClearSelection={handleClearSelection}
        getUsersList={getUsersList}
        triggerRefreshHandler={handleTriggerRefreshHandler}
        handleChangeLocallyStatus={handleChangeLocallyStatus}
        isMobileView={isMobileView}
      />


    </>
  )
}

export default UserContent
